<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline ps-2 pa-1">
                    {{ $t("companiesPage.createHotelAccount") }}
                  </div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-flex>
                  <v-flex>
                    <v-autocomplete
                      v-model="returnObject"
                      clearable
                      :items="hotels"
                      :loading="isLoading"
                      :search-input.sync="search"
                      outline
                      dense
                      :label="$t('companiesPage.hotelsLabel')"
                      item-text="name"
                      item-value="name"
                      :placeholder="$t('companiesPage.selectHotelPlaceholder')"
                      no-filter
                      return-object
                    >
                      <template slot="item" slot-scope="hotels">
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="hotels.item.name"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.username"
                      :rules="[rules.email]"
                      :label="$t('companiesPage.email')"
                      type="email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.password"
                      :rules="[rules.password]"
                      :label="$t('companiesPage.password')"
                      type="password"
                      dense
                    ></v-text-field
                  ></v-flex>

                  <v-flex>
                    <v-text-field
                      outline
                      v-model="model.phone_number"
                      :rules="[rules.phoneNumber]"
                      :label="$t('companiesPage.phoneNumber')"
                      type="phone"
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-btn
                  :loading="loading"
                  block
                  @click="createHotel"
                  color="secondary"
                  dark
                  >{{ $t("companiesPage.create") }}</v-btn
                >
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("companiesPage.hotelPageTitle");
  },
  data: () => ({
    hotels: [],
    returnObject: "",
    results: [],
    allResults: [],
    isLoading: false,
    search: null,
    loading: false,
    error: false,
    model: {
      full_name: "",
      username: "",
      password: "",
      phone_number: "",
      passenger_type: "HOTEL",
      hotel_id: 0,
    },
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
  }),

  computed: {
    rules() {
      return {
        email: (v) =>
          !!(v || "").match(/@/) || this.$t("companiesPage.ruleValidEmail"),
        length: (len) => (v) =>
          (v || "").length >= len ||
          this.$t("companiesPage.ruleCharLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) ||
          this.$t("companiesPage.rulePassword"),
        phoneNumber: (v) =>
          // (!!v &&
          //   v.search(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/) !== -1) ||
          // "Not a valid phone number !",

          (!!v && v.search(/^(00|\+)?[1-9]\d{6,}$$/) !== -1) ||
          this.$t("companiesPage.rulePhone"),

        required: (v) => !!v || this.$t("companiesPage.ruleRequired"),
      };
    },
  },

  watch: {
      search(val) {
        this.isLoading = true;
        const params = new URLSearchParams(this.initialSearchParams);
        params.append("search", val);
        this.axios
          .get("hotel", { params })
          .then((res) => {
            this.hotels = res.data.data.data.map((item) => ({
              ...item,
            }));
          })
          .catch((err) => console.log(err))
          .finally(() => (this.isLoading = false));
      },
    },

  methods: {
    createHotel() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        this.model.hotel_id = this.returnObject.id;
        this.model.full_name = this.returnObject.name;
        this.axios
          .post(this.api.ACTIONS.CREATE_PASSENGER, {
            ...this.model,
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("companiesPage.toastHotelCreated"),
              "green"
            );
            this.$router.push("/hotelsUsers");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("companiesPage.toastCheckInfo"),
                "red"
              );
            }
          })
          .then(() => (this.loading = false));
      }
      // }
    },
  },
};
</script>
